import { z } from 'zod';

export const embryoRecaneSchema = z.object({
  embryoId: z.string().uuid(),
  name: z.string(),
  currentCane: z.string().nullable().optional(),
  newCane: z.string().min(1, 'Cane code is required'),
});

export const recaneEmbryosFormSchema = z.object({
  embryos: z
    .array(embryoRecaneSchema)
    .min(1, 'At least one embryo is required'),
});

export type EmbryoRecaneFormValues = z.infer<typeof embryoRecaneSchema>;
export type EmbryoFormValues = z.infer<typeof recaneEmbryosFormSchema>;
